import { IS_HEBREW } from './locale';

import { getCustomFooterLinks } from 'src/utils/get-custom-footer-links';

export const CURRENCY_CENTS_COUNT = 100;
export const DEFAULT_LISTENER_DEBOUNCE_INTERVAL = 200;

export enum AppInstallation {
  CARNATION = 'carnation',
  HEBREW = 'hebrew',
  HUTTO = 'hutto',
  LBP = 'lbp',
  LOCUSTGROVE = 'locustgrove',
  PLEASANTHILL = 'pleasanthill',
  WOODLAWN = 'woodlawn',
}

export const INSTALLATION = (window.CEMETERY_INSTALLATION ?? '') as AppInstallation;

export const IS_MESHULAM_PAYMENT = INSTALLATION === AppInstallation.HEBREW;
export const PAYPAL_CLIENT_ID = window.PAYPAL_CLIENT_ID || '';

export const CUSTOM_FOOTER_LINKS = getCustomFooterLinks();
export const GTM_ID = window.GOOGLE_TAG_MANAGER_ID;
export const CEMETERY_URL =
  CUSTOM_FOOTER_LINKS?.find(({ isCemeteryUrlLink }) => isCemeteryUrlLink)?.url ||
  window.CEMETERY_URL ||
  '';
export const CNAME = `${window.CNAME ?? ''}`.replace(/\/+$/, '');
export const ABOUT_LINK = IS_HEBREW ? `${CNAME}/about` : CEMETERY_URL;
export const INDEX_PAGE_LINK = `${CNAME}/burial-records/`;
export const IS_HIDE_COOKIES_POPUP = window.HIDE_COOKIES_POPUP === true;
export const IS_HUTTO_CEMETERY = INSTALLATION === AppInstallation.HUTTO;
export const NO_SLUG = window.NO_SLUG === true;
export const HEADER_PHONE = window.HEADER_PHONE || '';
export const HEADER_PHONE_TEXT = window.HEADER_PHONE_TEXT || '';
export const SERVICES_NO_SLUG_URL = window.ORDER_SERVICES_NO_SLUG_URL;
export const WITH_PHONE = IS_HEBREW && !!HEADER_PHONE;
